import useEvent from "react-use-event-hook";
import { useSetRecoilState } from "recoil";

import {
  BOOKINGS_URL,
  BookingsRoutes,
  generateSpecificSearchPattern,
  saveLastNavigation,
  starredDisplayModeAtomFamily,
  StarredDisplayModeEnum,
  tableSearchAF,
  usePrefixedRouting,
} from "@ryde/shared";

import { useDynamicFormsFetch } from "../../use-dynamic-forms-fetch";

const FETCH_BOOKINGS_DELAY_MS = 100;

export const useBookingsByIdsNavigation = () => {
  const { navigatePrefixed } = usePrefixedRouting();
  const setTableSearch = useSetRecoilState(tableSearchAF("booking"));
  const setStarredDisplayMode = useSetRecoilState(
    starredDisplayModeAtomFamily("booking"),
  );
  const { fetchTableRowsServerFiltered: fetchBookings } = useDynamicFormsFetch(
    "booking",
    "bookings",
  );

  const navigateToBookingsByIds = useEvent((bookingIds: number[]): void => {
    if (!bookingIds?.length) {
      return;
    }
    setStarredDisplayMode(StarredDisplayModeEnum.ShowAllIncludeStarred);
    setTableSearch(generateSpecificSearchPattern(bookingIds));
    navigatePrefixed(BookingsRoutes.SEARCH_GRID);
    saveLastNavigation({
      route: BOOKINGS_URL,
      path: BookingsRoutes.SEARCH_GRID,
    });
    setTimeout(() => fetchBookings(), FETCH_BOOKINGS_DELAY_MS);
  });

  return { navigateToBookingsByIds };
};
